import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

function ContractList({ children }: Props) {
  return <div className='ContractList'>{children}</div>;
}

export default ContractList;
